import React from 'react';
import { Form } from 'react-bootstrap';

const LocationType = ({ name, value, handleChange }) => {
  return (
    <Form.Select value={value} name={name} onChange={handleChange} className="input">
      <option value="">All</option>
      <option value="office">Office</option>
      <option value="factory">Factory</option>
      <option value="outlet">Outlet</option>
      <option value="staff-room">Staff Room</option>
    </Form.Select>
  );
};

export default LocationType;
